import { render, staticRenderFns } from "./Pile.vue?vue&type=template&id=21cc0774&"
import script from "./Pile.vue?vue&type=script&lang=ts&"
export * from "./Pile.vue?vue&type=script&lang=ts&"
import style0 from "./Pile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports